export default {
  install(Vue, options) {
    //验证当前用户是否有操作权限
    Vue.prototype.hasPermission = function(val){
        var permissions = JSON.parse(localStorage.getItem("CURRENTUSER")).permissions;
        if (permissions != null) {
          var index = permissions.indexOf(val);
          if(index == -1){
            return false;
          }else{
            return true;
          }
        } else {
          return false;
        }
    };
    //table日期格式化
    Vue.prototype.tableDateFormat = function (row, column) {
      var rowDate = row[column.property];
      if (rowDate == null || rowDate == "") {
        return '';
      } else {
        var date = new Date(rowDate);
        if (date == undefined) {
          return rowDate;
        }
        var month = '' + (date.getMonth() + 1),
          day = '' + date.getDate(),
          year = date.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        var newDate = [year, month, day].join('-');
        return newDate;
      }
    }

    //table日期格式化-年月日时分秒
    Vue.prototype.tableDateFormat2 = function (row, column) {
      var rowDate = row[column.property];
      if (rowDate == null || rowDate == "") {
        return '';
      } else {
        var date = new Date(rowDate);
        if (date == undefined) {
          return rowDate;
        }
        var month = '' + (date.getMonth() + 1),
          day = '' + date.getDate(),
          year = date.getFullYear(),
          hour = '' + date.getHours(),
          minute = '' + date.getMinutes(),
          second = '' + date.getSeconds();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        if (hour.length < 2) hour = '0' + hour;
        if (minute.length < 2) minute = '0' + minute;
        if (second.length < 2) second = '0' + second;

        var newDate = [year, month, day].join('-');
        var newTime = [hour, minute, second].join(':');
        return newDate + ' ' + newTime;
      }
    }

    //table中NULL值格式化
    Vue.prototype.tableNullFormat = function (row, column) {
    var rowDate = row[column.property];
      if (rowDate == null || rowDate == "") {
        return '';
      } else {
        return rowDate;
      }
    }

    //table中性别格式化
    Vue.prototype.tableSexFormat = function(row, column) {
      switch (row[column.property]) {
        case "1":
          return "男";
        case "2":
          return "女";
        default:
          return "";
      }
    },

    //table每4位加一个空格格式化
    Vue.prototype.tableLongNumFormat =  function (row, column) {
      var rowNum = row[column.property];
      if (rowNum == null || rowNum == "") {
        return '';
      } else {
        return rowNum.replace(/(.{4})/g,'$1 ');
      }
    }

    //table百分数格式化
    Vue.prototype.tablePercentFormat = function (row, column) {
      var rowNum = row[column.property];
      if (rowNum == null || rowNum == "" || rowNum == "-1") {
        return '-';
      } else {
        return Math.round(rowNum*100*100)/100 + "%";
      }
    }

    //table的行样式
    Vue.prototype.rowStyle = function() {
      return {height: '40px'};
    }

    //日期格式化
    Vue.prototype.dateFormat1 = function(val){
      var date = new Date(val);
      if (date == undefined) {
        return val;
      }
      var month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      var newDate = [year, month, day].join('-');
      return newDate;
    }

    //字符串每4位加一个空格
    Vue.prototype.longNumFormat = function(val){
      if(val == null){
          return null;
      }else{
          return val.replace(/(.{4})/g,'$1 ');
      }
    }
    //剩余多少个字
    Vue.prototype.checkWord = function(text, name, maxlength) {
      if (text != "" && text != null && text != undefined) {
        var length = text.length;
        var curr = maxlength - length;
        var ele = document.getElementById(name);
        if (ele != null) {
          document.getElementById(name).innerHTML = curr.toString();
        }
      }else{
        var ele = document.getElementById(name);
        if (ele != null) {
          document.getElementById(name).innerHTML = maxlength.toString();
        }
      }
    }
    //英文剩余多少个字 add by yushch 20221118
    Vue.prototype.checkEngWord = function(text, name, maxlength) {
      if (text != "" && text != null && text != undefined) {
        //换行符、前后空格不计数
        text = text.replace(/\n|\r|^\s+|\s+$/gi,"");
        //多个空格替换成一个空格
        text = text.replace(/\s+/gi," ");
        var length = 0;
        var match = text.match(/\s/g);
        if(match){
          length = match.length +1;
        }else{
          length = 1;
        }
        var curr = maxlength - length;
        var ele = document.getElementById(name);
        if (ele != null) {
          document.getElementById(name).innerHTML = curr.toString();
        }
      }else{
        var ele = document.getElementById(name);
        if (ele != null) {
          document.getElementById(name).innerHTML = maxlength.toString();
        }
      }
    }

       //判断属性值是否相等
    Vue.prototype.checkAttrValue  = function(val,value) {
//  	console.log(val+"==="+value)
    	if(val==value){
    		return true;
    	}
      return false;
    }

    //获取当前客户端IP
    Vue.prototype.getIp = function() {
      return returnCitySN["cip"];
    }
    //下载文件系统文件
    Vue.prototype.download = function(data,filename) {
      if (!data&&!filename) {
        return
      }
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    }
    Vue.prototype.back2plot = function(bd,lan,isBoothStart,yxzwData) {
      var pd = {};
      pd.uuid = bd.uuid;
      pd.code = bd.zwh;
      pd.codeFontSize = parseInt(bd.bhzh);
      pd.codeFontStyle = bd.bhzc;
      pd.codeFontFamily = bd.bhzt;
      pd.name = bd.zwmc;
      pd.nameFontSize = parseInt(bd.mczh);
      pd.nameFontStyle = bd.mczc;
      pd.nameFontFamily = bd.mczt;

      //add by yushch 2023-02-17 
      var count = bd.zwh.split("-").length -1;
      if(count == 2){
        var index = bd.zwh.lastIndexOf("-");
        pd.codeBody = bd.zwh.substring(0,index);
        pd.codeIndex = bd.zwh.substring(index+1,bd.zwh.length);
      }else{
        pd.codeBody = bd.zwh;
      }
      //yushch add end

      //企业全称
      pd.fullName = bd.qymc;
      pd.lateralLength = parseFloat(bd.zwcd);
      pd.verticalLength = parseFloat(bd.zwkd);
      pd.area = parseFloat(bd.zwmj);
      pd.status = bd.zwzt;

      pd.stageUuid = bd.zgid;
      pd.shapeUuid = bd.reserve1;
      pd.tenantId = bd.qyid;
      pd.lan = lan;

      pd.top = bd.top;
      pd.bottom = bd.bottom;
      pd.left = bd.left;
      pd.right = bd.right;
      pd.isSpecial = bd.isSpecial;
      pd.czlx = bd.czlx;

      if(pd.lan && pd.lan == 'ENG'){
        pd.boothType = bd.zwlb;
        //出口类型
        pd.entryType = bd.cklx;

        //展位类别，出口类型翻译
        if (bd.zwlb == "标准展位") {
          bd.zwlb = "Standard booth";
        }
        if (bd.zwlb == "光地") {
          bd.zwlb = "Raw space";
        }
        if (bd.cklx == "一面开") {
          bd.cklx = "1 Sides open";
        }
        if (bd.cklx == "两面开") {
          bd.cklx = "2 Sides open";
        }
        if (bd.cklx == "三面开") {
          bd.cklx = "3 Sides open";
        }
        if (bd.cklx == "全开") {
          bd.cklx = "4 Sides open";
        }
      }

      //展位类型
      pd.boothType = bd.zwlb;
      //出口类型
      pd.entryType = bd.cklx;
      //企业名称(全用简称)
      //pd.tenantName = bd.qymc;

      pd.tenantName = bd.gsjc;
      if (bd.zwzt != "function" ){
        pd.name = bd.gsjc;
        //------------------------------------二批选展位-------------------------
        // if (isBoothStart == false) {
        //     //如果展位状态为内部预留则展位显示初始状态
        //     if (bd.zwzt == "bespoke" || bd.zwzt == "occupy") {
        //       pd.status = "normal";
        //       pd.name = "";
        //       pd.tenantName = "";
        //       pd.fullName = "";
        //     }
        //  }
        //------------------------------------二批选展位-------------------------
          //当前企业查看本公司展位为红色
        for (var j in yxzwData) {
            if (yxzwData[j].zwh == bd.zwh) {
              pd.status = "allotted";
              if (bd.gsjc) {
                pd.name = bd.gsjc;
              }
            }
        }
      }
      return pd;
    }

    Vue.prototype.digitUppercase = function(n) {
       var fraction = ['角', '分'];
          var digit = [
              '零', '壹', '贰', '叁', '肆',
              '伍', '陆', '柒', '捌', '玖'
          ];
          var unit = [
              ['元', '万', '亿'],
              ['', '拾', '佰', '仟']
          ];
          var head = n < 0 ? '欠' : '';
          n = Math.abs(n);
          var s = '';
          for (var i = 0; i < fraction.length; i++) {
              s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
          }
          //s = s || '整';
          n = Math.floor(n);
          for (var i = 0; i < unit[0].length && n > 0; i++) {
              var p = '';
              for (var j = 0; j < unit[1].length && n > 0; j++) {
                  p = digit[n % 10] + unit[1][j] + p;
                  n = Math.floor(n / 10);
              }
              s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
          }
          return head + s.replace(/(零.)*零元/, '元')
              .replace(/(零.)+/g, '零')
              .replace(/^整$/, '零元');
    }
    Vue.prototype.isNumber = function(val) {
          var regPos = /^\d+(\.\d+)?$/; //非负浮点数
          var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
          if(regPos.test(val) || regNeg.test(val)){
              return true;
          }else{
              return false;
          }
    }
    //格式 Apr 29,2020
    Vue.prototype.formateENDate = function(val) {
         if(val.indexOf("年")>-1){
           val = val.replace("年","-").replace("月","-").replace("日","")
         }
         var dateStrs = val.split("-");

         var year = parseInt(dateStrs[0], 10);

         var month = parseInt(dateStrs[1], 10) - 1;

         var day = parseInt(dateStrs[2], 10);


         var dt = new Date(year, month, day);

        // var dt = new Date();
         var m=new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec");
         var w=new Array("Monday","Tuseday","Wednesday","Thursday","Friday","Saturday","Sunday");
         var d=new Array("st","nd","rd","th");
         var mn=dt.getMonth();
         var wn=dt.getDay();
         var dn=dt.getDate();
         var dns;
         if(((dn%10)<1) ||((dn%10)>3)){
          dns=d[3];
         }
         else
         {
         dns=d[(dn%10)-1];
           if((dn==11)||(dn==12)){
            dns=d[3];
           }
         }
        return m[mn]+" "+dn+","+dt.getFullYear();
    }

  }
}



// WEBPACK FOOTER //
// ./src/common/js/utils.js